import { GroupDetailsPage } from "@/modules/community-groups/components/Details/Details";

export function HelpCategoryDetailsPage(): React.ReactNode {
  return <GroupDetailsPage />;
}
